import { MainFeatureType } from '@/types/main-feature.type';

export const mainFeatures: MainFeatureType[] = [
  {
    imageSrc: '/images/main/feature1.webp',
    imageAlt: '기능시험, 도로주행 시뮬레이터',
    subtitle: '전국 모든 시험장 코스의',
    title: '기능시험, 도로주행을 그대로',
    description:
      '전국 23개 운전면허시험장에서 실시하는\n 기능시험, 도로주행 시험 코스를 3D로 동일하게\n 구현하여 현실감 넘치는 연습이 가능합니다.',
  },
  {
    imageSrc: '/images/main/feature2.webp',
    imageAlt: 'T자코스 무한연습',
    subtitle: '어려운 코스만 집중적으로',
    title: '무한반복 연습',
    description:
      '시뮬레이터의 가장 큰 장점인 무한 반복 연습을 통해\n 운전면허시험장의 어려운 코스만 집중적으로 연습하여\n 효율적으로 학습하고 합격률을 극대화할 수 있어요.',
  },
  {
    imageSrc: '/images/main/feature3.webp',
    imageAlt: '안전한 운전연습',
    subtitle: '다칠 일이 전혀 없는',
    title: '안전한 운전연습',
    description:
      '운전연습 중 사고가 발생하더라도 운전시뮬레이션은\n 어떠한 물리적 충돌이나 피해가 없기 때문에, 부모님들도\n 안심하고 자녀의 교육을 맡길 수 있어요',
  },
  {
    imageSrc: '/images/main/feature4.webp',
    imageAlt: '커리큘럼',
    subtitle: '국가공인 운전 강사의',
    title: '운전면허교육 커리큘럼',
    description:
      '국가공인 운전 강사들이 연구한 자체 운전면허교육\n 커리큘럼을 통해 합격을 위한 내용들만\n 체계적으로 지도합니다.',
  },
];
